import { MessageSquare, Plus } from "lucide-react";
import type React from "react";
import { ThreadTab } from "@/features/chat/components/ThreadTab";
import type { ChatThread } from "@/features/chat/services/chatService";

interface ThreadTabsBarProps {
	threads: ChatThread[];
	selectedThreadId: string | null;
	onSelectThread: (threadId: string) => void;
	onDeleteThread: (threadId: string, event: React.MouseEvent) => void;
	onNewThread: () => void;
	disableNewThread?: boolean;
}

export const ThreadTabsBar: React.FC<ThreadTabsBarProps> = ({
	threads,
	selectedThreadId,
	onSelectThread,
	onDeleteThread,
	onNewThread,
	disableNewThread,
}) => {
	const hasThreads = threads.length > 0;

	return (
		<div className="chat-thread-bar">
			<div className="chat-thread-scroll">
				{!hasThreads ? (
					<div className="chat-thread-empty">
						<MessageSquare className="h-4 w-4 shrink-0 opacity-50" />
						<span>No threads yet</span>
					</div>
				) : (
					<div className="flex items-center">
						{threads.map((thread, index) => {
							if (!thread) return null;
							const key = thread.id ?? `thread-${index}`;
							return (
								<ThreadTab
									key={key}
									thread={thread}
									isSelected={selectedThreadId === thread.id}
									onSelect={onSelectThread}
									onDelete={onDeleteThread}
								/>
							);
						})}
					</div>
				)}
			</div>
			<button
				type="button"
				onClick={onNewThread}
				disabled={disableNewThread}
				className="chat-thread-new-btn disabled:opacity-50 disabled:cursor-not-allowed"
				aria-label="New thread"
			>
				<Plus className="h-4 w-4" />
			</button>
		</div>
	);
};
